import React, { useContext, useEffect, useState } from "react";
import Wrapper from "../../../../components/common/Wrapper/Wrapper";
import organisms from "../../../../components/organisms";
import service from "../../../../api/services";
import { Contact_lens, Default_Page_Limit, Default_Page_Number } from "../../../../constants/defaultValues";
import { HeaderHeading } from '../../../../Context'
import { BASE_URL } from "../../../../constants/defaultValues"
import constant from "../../../../constants/constant";
import { useSearchParams } from "react-router-dom";
import { getContactLensType, getParams } from "../../../../constants/utils";
import { useToasts } from "react-toast-notifications";
import { DropDownType, FilterDataProps, ModifiedDataForContactLensProps } from "./interface";

const { PendingProduct } = organisms

const Index = () => {
    const { addToast } = useToasts();
    const [searchParams] = useSearchParams();
    const [typeValue, setTypeValue] = useState<any>(getParams('pending_product_type'))
    const [productData, setProductData] = useState<any>({})
    const [currentPage, setCurrentPage] = useState(Default_Page_Number);
    const [productDetail, setProductDetail] = useState({});
    const [limitPerPage, setLimitPerPage] = useState(Default_Page_Limit);
    const [search, setSearch] = useState('');
    const { setHeader, }: any = useContext(HeaderHeading);
    const [productTypeList, setProductTypeList] = useState<DropDownType[]>([])
    const [brandList, setBrandList] = useState<DropDownType[]>([])
    const [filterData,setFilterData] = useState<FilterDataProps>({
        product_type_id:null,
        brand_id:null,
        modal_number:""
    })
    const [isContactLensProduct, setIsContactLensProduct] = useState<boolean>(getContactLensType())
    const [showFilter,setShowFilter] = useState<boolean>(false)

    const getDropdown = (response: []) => {
        let dropdown: any = []
        response && response.map((value: any) => {
            dropdown.push({
                "value": value.id || value.product_type.id,
                "label": value.name || value.brand_name || value.color_name || value.product_type.name,
                "code": value?.brand_code || value?.product_type_initials || value?.product_type?.product_type_initials
            }
            )
        })
        return dropdown
    }

    const getAllDetail = async () => {
        const brands = filterData?.brand_id?.map((item: any) => item?.value)
        const product_types = filterData?.product_type_id?.map((item: any) => item?.value)
        let NewBrands = JSON.stringify(brands)
        let NewProductTypes = JSON.stringify(product_types)
        try {
            let response = await service.product.view(
                {
                    "page": currentPage,
                    "search": search,
                    "limit": limitPerPage,
                    "status": constant.VERIFICATION_STATUS.PENDING,
                    "brands": NewBrands,
                    "product_types": NewProductTypes,
                    "modal_number": filterData?.modal_number,
                    "brand_category": typeValue,
                    "is_contact_lens": isContactLensProduct
                }
            )
            if (response.status === 200) {
                setProductData(response.data)
                localStorage.removeItem('isContactLensProduct')
            }
        } catch (error: any) {
            console.error(error)
            addToast(error.response.data.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }

    const getDetailById = async (id: string) => {
        try {
            let response = await service.product.getDetailById(id)
            if (response.status === 200)

                setProductDetail(response.data.data)
            } catch (error: any) {
                console.error(error)
                addToast(error.response.data.message, {
                    appearance: 'error',
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
            }
    }

    const handleChange=(name:string , value:string | DropDownType)=>{
        setFilterData((prevState:FilterDataProps)=>({...prevState, [name]:value}))
    }

    // get the data for filter
    const modifiedDataForContactLens = ({ data, filterCondition }: ModifiedDataForContactLensProps) => {
        return data?.filter(filterCondition) || []
    }

    const getProductData=async()=>{
        try {
            let brandResponse = await service.product.getFilterBrand({ brand_category: typeValue })
            let productTypeResponse = await service.inventory.commonProductTypeListingService({ search: '' });
            setBrandList(getDropdown(brandResponse?.data?.data))
            let modifiedData: any = modifiedDataForContactLens({
                data: productTypeResponse.data.data, filterCondition: (item: any) => (item?.name
                )?.toLowerCase() !== Contact_lens
            })
            if (productTypeResponse.status === 200) {
                setProductTypeList(getDropdown(modifiedData))
            }
        } catch (error) {
            console.error(error)
        }
    }
    // end

    // handle the contact lens switch to normal product and vice versa
    const handleChangeContactLens=(value:boolean)=>{
        setIsContactLensProduct(value);
        setFilterData({
            product_type_id: null,
            brand_id: null,
            modal_number: "",
        })
    }
        // end

    useEffect(() => {
        setProductDetail({})
        setTypeValue(getParams('pending_product_type'))
        setCurrentPage(Default_Page_Number)
        setLimitPerPage(Default_Page_Limit)
        setSearch('')
    }, [searchParams])

  
    useEffect(() => {
        setHeader("Product - Pending")
        getAllDetail()
    }, [currentPage, typeValue, limitPerPage, search, isContactLensProduct,filterData])

    useEffect(()=>{
        getProductData()
    },[typeValue])

    return (
        <Wrapper>
            <PendingProduct
                productResponse={productData}
                productDetail={productDetail && productDetail}
                updateVerificationStatus={(id: string, status: number) => { }}
                getDetailById={(id: string) => { getDetailById(id) }}
                setLimitPerPage={setLimitPerPage}
                setCurrentPage={setCurrentPage}
                setSearch={setSearch} currentPage={currentPage} limit={limitPerPage}
                isRecognize={typeValue == constant.BRAND_CATEGORY[0].value}
                setIsContactLensProduct={(value:boolean)=>handleChangeContactLens(value)}
                isContactLensProduct={isContactLensProduct}
                setShowFilter={(value:boolean)=>setShowFilter(value)}
                showFilter={showFilter}
                brandList={brandList}
                productTypeList={productTypeList}
                handleChange={handleChange}
                filterData={filterData}
            />
        </Wrapper>
    )

}
export default Index